module.exports = __webpack_public_path__ + "static/img/home-back.0bf3ef0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-back.jpg
// module id = y1Ko
// module chunks = 1